import {
  UpdatePersonTenantAssociationRoleMutation,
  UpdatePersonTenantAssociationRoleMutationVariables
} from './__generated__/UpdatePersonTenantAssociationRoleMutation'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdatePersonTenantAssociationRoleMutation($personTenantAssociationId: String!, $newRole: String!) {
    updatePersonTenantAssociationMutation(
      input: { newRole: { role: $newRole }, personTenantAssociationId: $personTenantAssociationId }
    ) {
      id
    }
  }
`

export const useUpdatePersonTenantAssociationRole = () =>
  useMutation<UpdatePersonTenantAssociationRoleMutation, UpdatePersonTenantAssociationRoleMutationVariables>(MUTATION)
